import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Input from "@inspinia-react/form/input/input";

import { setLoading } from "@inspinia-react/actions";
import {
  setPostalCode,
  setStreetNumber,
  setComplement,
  setStateLocation,
  setCityLocation,
  setStreet,
  setDistrict,
} from "../actions";

import { searchPostalCode } from "../../../../utils";

import { getStates, searchCities } from "../../utils";
import { mapTest } from "../../../pages/products/map.test";

class PostalCode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
      error: false,
    };
    this._changeInput = this._changeInput.bind(this);
  }
  _getState(ufCode, cityName) {
    const payload = (states) => {
      const [state] = states;
      state.label = state.uf;
      state.value = state.id;
      this.props.setStateLocation(state);
      const payloadCity = (cities) => {
        const [city] = cities;
        city.label = city.city_name;
        city.value = city.id;
        this.props.setCityLocation(city);
      };
      searchCities(ufCode, cityName, payloadCity);
    };
    getStates(payload, ufCode);
  }

  _setDataToProps(data) {
    this.props.setDistrict(data.bairro);
    this.props.setStreet(data.logradouro);
    this.props.setComplement(data.complemento);
    this._getState([data.ibge[0], data.ibge[1]].join(""), data.localidade);
  }

  search() {
    const { inputValue } = this.state;
    if (inputValue.length === 8) {
      this.props.setLoading(true);
      const payload = (result) => {
        this.props.setLoading(false);
        this.setState({ ...this, error: false });
        if (result.erro) {
          this.setState({ ...this, error: true });
          return;
        }
        this._setDataToProps(result);
      };
      const failPayload = (error) => {
        this.props.setLoading(false);
        this.setState({ ...this, error: true });
      };
      searchPostalCode(inputValue, payload, failPayload);
    }
  }
  _changeInput(inputValue) {
    this.setState({ ...this, inputValue });
    this.props.setPostalCode(inputValue);
    this.forceUpdate();
    setTimeout(() => {
      this.search();
    }, 100);
  }
  UNSAFE_componentWillMount() {}
  render() {
    return (
      <div >
        CEP
        <Input
          id = {mapTest.createBranch.address.fields.inputPostalCode}
          onChange={this._changeInput}
          value={this.props.postalCode}
          placeholder="Insira o CEP aqui"
          data-address-input-postal-code
          mask="99999-999"
          disabled={this.props.loading}
        />
        {this.state.error ? (
          <small className="text-danger">CEP Inválido</small>
        ) : (
          <div />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
  postalCode: state.postalCode,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPostalCode,
      setStreetNumber,
      setComplement,
      setStateLocation,
      setCityLocation,
      setStreet,
      setDistrict,
      setLoading,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(PostalCode);



// WEBPACK FOOTER //
// ./src/components/parts/address-component/postal-code/index.jsx